import React, { useEffect, useState } from "react";
import { Inputs, Tabbles } from "../../../components";
import { PiClockUserLight, PiStethoscope, PiTrash } from "react-icons/pi";
import { useDispatch } from "react-redux";
import { actionDoctor } from "../../../redux/actions";
import { useAlert } from "../../../contexts";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Accepted = ({ acceptedData, loginData }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showAlert } = useAlert();
    const [data, setData] = useState(acceptedData || []);
    useEffect(() => {
        if (acceptedData) {
            setData(acceptedData);
        }
    }, [acceptedData]);

    const handleToggle = (index) => {
        const newData = [...data];
        newData[index].isActive = !newData[index].isActive;
        setData(newData);

        const credentials = {
            doctorClinicRequestGuid: newData[index].doctorClinicRequestGuid,
            clinicGuid: loginData.clinicGuid,
            doctorGuid: newData[index].doctorGuid,
            isActive: newData[index].isActive,
            status: newData[index].status,
        };

        dispatch(
            actionDoctor.postSendDoctorClinicRequest(
                credentials,
                (error, response) => {
                    if (error) {
                        if (error.data) {
                            if (error.data.statusCode === 400) {
                                if (error.data.message) {
                                    showAlert("danger", error.data.message, `${t("Error")} : `);
                                } else {
                                    if (error.data.error && error.data.error.ValidationErrors) {
                                        error.data.error.ValidationErrors.forEach(
                                            (validationError) => {
                                                console.error(
                                                    `${t("Field")}: ${validationError.Field} - ${t(
                                                        "Message"
                                                    )}: ${validationError.Message}`
                                                );

                                                showAlert(
                                                    "danger",
                                                    validationError.Message,
                                                    `${t("Error")} : ${validationError.Field}`
                                                );
                                            }
                                        );
                                    } else {
                                        showAlert(
                                            "danger",
                                            `${t("Invalid_credentials")}`,
                                            `${t("Error")} !`
                                        );
                                    }
                                }
                            } else {
                                showAlert(
                                    "danger",
                                    `${t("unexpected_error")}``${t("Error")} !`
                                );
                            }
                        }
                    } else if (response) {
                        if (response.status === 200) {
                            showAlert(
                                "success",
                                newData[index].isActive
                                    ? t("doctor.my_doctor.doctor_activation_success")
                                    : t("doctor.my_doctor.doctor_deactivation_success"),
                                t("success")
                            );
                            dispatch(
                                actionDoctor.getAllClinicRequests(loginData.clinicGuid, null)
                            );
                        }
                    }
                }
            )
        );
    };
    return (
        <div className="accepted-block">
            <Tabbles.TableBlk
                headerIcon={<PiStethoscope className="header-Icn" />}
                heading={t("accepted_specialist")}
                columns={[
                    `${t("no")}`,
                    `${t("specialist_name")}`,
                    `${t("phone_number")}`,
                    `${t("email")} ${t("Address")}`,
                    `${t("medical_specialty")}`,
                    `${t("status")}`,
                    `${t("Schedule")}`,
                    `${t("delete")}`,
                ]}
                data={data?.map((accepted, index) => ({
                    [t("no")]: index + 1,
                    [t("specialist_name")]: (<span onClick={() => navigate(`/doctor/doctor-detail`, { state: { doctorDetails: accepted } })} className="custom-cursor-pointer" >{accepted.doctorName}</span>),
                    [t("phone_number")]: accepted.mobile,
                    [`${t("email")} ${t("Address")}`]: accepted.email,
                    [t("medical_specialty")]: accepted.speciality,
                    [t("status")]: (
                        <Inputs.CheckRadioInput
                            type="checkbox"
                            checked={accepted.isActive}
                            onChange={() => handleToggle(index)}
                            className="form-grp-check-toggle"
                        />
                    ),
                    [t("Schedule")]: (
                        <div className="editBlkIcon custom-cursor-pointer" onClick={() => navigate(`/doctor/doctor-Schedule/default-working-time`, { state: { doctorDetails: accepted } })}>
                            <PiClockUserLight
                                // onClick={() => handleEditDefaultWorkingTime(Appointment)}
                                className="editIcon"
                            />
                        </div>
                    ),
                    [t("delete")]: (
                        <PiTrash
                            // onClick={() =>
                            //     handleDeleteDefaultWorkingTime(Appointment.defaultTimingGuid)
                            // }
                            className="delIcon noVerify"
                        />
                    ),
                }))}
                tabbleClassname="tabble"
            />
        </div>
    );
};

export default Accepted;
